import { useQuery } from 'react-query';
import makeApiRequest from 'services/makeApiRequest';
import apiEndPoints from 'services/apiEndPoints';
import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useCompanyDetails(id) {
  return useQuery(['company-details-super-admin', id], async () => {
    const response = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.COMPANY_DETAILS, {
        company_id: id,
      })
    );
    return response?.data;
  });
}
